import React from "react";
import NavbarFr from "components/NavbarFr";
import FooterFr from "components/FooterFr";
import TeamsFr from "components/AboutUs/TeamsFr";
import { useSelector } from "react-redux";
import MobileNavbarFr from "components/MobileNavbarFr";
import MobileFooterFr from "components/MobileFooterFr";
import { useEffect } from "react";

function AboutUsFr () {

    const isMobile = useSelector(state => state.windowSize.isMobile);
    
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbarFr />
            <TeamsFr />
            <MobileFooterFr />
            </>
        ) : (
            <>
            <NavbarFr />
            <TeamsFr />
            <FooterFr />
        </>
        )}
        </>
    )
};

export default AboutUsFr